<template>
  <div id="yhubIndex" class="">
    <!-- 表格删选 -->
    <div style="padding: 20px 0 0 20px">
      <el-input v-model="seachObj.yhubSn" clearable :placeholder="$t('AllDevices.SearchDeviceSn')"
        class="input-with-select deviceNameTable" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeSearch" />
      <div class="fwWarp">
        <el-input v-model.trim="seachObj.fw" :placeholder="$t('adminView.Version')" clearable class="fwInput"
          @blur="inputFwBlur" />
        <el-select id="isEqual" v-model="seachObj.isEqual" filterable placeholder="请选择" @change="changeSearch">
          <el-option v-for="(item, index) in isEqualOptions" :key="index" :label="item.label" :value="item.key" />
        </el-select>
      </div>
    </div>
    <el-row id="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 列表 -->
        <div style="position: relative; padding: 10px 20px 20px; width: 100%">
          <div v-if="isShowLoading" class="loading">
            <div class="el-icon-loading" style="font-size: 2em" />
          </div>
          <el-table :data="tableData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }" border>
            <!-- <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.capacity')">
                      <span>{{ scope.row.expand.batteryTotalAh }} Ah</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.PowerUp')">
                      <span>{{ scope.row.expand.bootupTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.SettCreated')">
                      <span>{{ scope.row.expand.configTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.Created')">
                      <span>{{ scope.row.expand.createTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.networkModule')">
                      <span>{{ scope.row.expand.netModuleVersion }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.IMEI')">
                      <span>{{ scope.row.expand.netModuleImei }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.YhubVersion')">
                      <span>{{ scope.row.expand.protocolVersion }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.SIMID')">
                      <span>{{ scope.row.expand.netModuleSimId }}</span>
                      <el-button type="primary" icon="el-icon-refresh" size="mini" @click="refreshSim(scope.row)" />
                      <el-button type="primary" icon="el-icon-setting" size="mini" title="copy data" @click="toCopyData(scope.row)" />
                    </el-form-item>
                  </el-col>
                  <el-col v-if="$store.state.isAdmin" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.Type')">
                      <span v-if="scope.row.simType==1">263 {{ $t('sim.card') }}</span>
                      <span v-else-if="scope.row.simType==2">keepgo {{ $t('sim.card') }}</span>
                      <span v-else-if="scope.row.simType==3">datamobile {{ $t('sim.card') }}</span>
                      <span v-else-if="scope.row.simType==4">simboss {{ $t('sim.card') }}</span>
                      <span v-else>--</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="$store.state.isAdmin" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('sim.MonthlyTraffic')">
                      <span>{{ scope.row.simFlowAmount.toFixed(2) }}M</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="$store.state.isAdmin" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('sim.UsedTraffic')">
                      <span>{{ scope.row.realFlowZh }}M</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="$store.state.isAdmin" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="scope.row.traffic>=0?$t('sim.RemainFlow'):$t('sim.Overflow')">
                      <span :style="{color:scope.row.traffic<0?'red':''}">{{ scope.row.traffic>=0?scope.row.traffic:-scope.row.traffic }}M</span>
                    </el-form-item>
                  </el-col>
                </el-form>
              </template>
            </el-table-column> -->
            <el-table-column prop="yhubSn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
            <!-- <el-table-column prop="yhubMcu" :label="$t('BondOrUpdateDevice.MCUID')" align="center" /> -->
            <el-table-column prop="hardware" :label="$t('adminView.hardwareVersion')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center">
                  {{ scope.row.hardware }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hardware" :label="$t('adminView.Version')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center">
                   V{{ scope.row.fwVersion }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="limitSendFreq" :label="$t('adminView.limitSendFreq')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center">
                  {{ scope.row.limitSendFreq||'--' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="onlineStatus" :label="$t('adminView.NetworkStatus')" sortable align="center">
              <template slot-scope="scope">
                <div style="text-align: center">
                  <el-button v-if="
                      scope.row.onlineStatus == null ||
                        scope.row.onlineStatus == '0'
                    " size="mini" type="danger" plain>{{ $t("adminView.Offline") }}</el-button>
                  <el-button v-if="scope.row.onlineStatus == '1'" size="mini" type="success"
                    plain>{{ $t("adminView.Online") }}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="lastConnectTime" :label="$t('adminView.LastConnection')" align="center" />
            <el-table-column :label="$t('yhubReport.Operating')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center">
                  <el-button v-if="!scope.row.hardware.includes('Lite')" type="primary" icon="el-icon-view " size="mini" @click="goToDetail(scope.row)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="
              background-color: white;
              width: 100%;
              border-radius: 0 0 10px 10px;
            ">
            <div class="pagination-container">
              <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
                :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog :close-on-click-modal="false" :title="$t('adminView.copyDataPopTitle')" class="statusPop" width="40%"
      :visible.sync="showMovePop">
      <el-form ref="dataForm" :model="moveObj" label-position="right" label-width="160px">
        <div class="box">
          <el-form-item :label="$t('adminView.oldDevice')">
            <el-input v-model="moveObj.fromMcuId" style="width: 230px" :disabled="true" @input="change($event)" />
          </el-form-item>
          <el-form-item :label="$t('adminView.newDevice')">
            <el-input v-model="moveObj.toMcuId" style="width: 230px" @input="change($event)" />
          </el-form-item>
          <el-form-item :label="$t('adminView.cleanData')">
            <!--是否清空原始数据-->
            <el-radio v-model="moveObj.clear" :label="1" @input="change($event)">
              {{ $t("adminView.Yes") }}</el-radio>
            <el-radio v-model="moveObj.clear" :label="0" @input="change($event)">
              {{ $t("adminView.no") }}</el-radio>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex; justify-content: flex-end">
        <el-button @click="showMovePop = false">{{
          $t("button.Cancel")
        }}</el-button>
        <el-button class="filter-item" type="primary" @click="copyData">{{
          $t("button.Confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUpdateDeviceList,
  getLastMessageBootReq,
  manualUpdateSimList,
  doCopyData
} from '@/api/firmwareUpdate'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'DashboardAdmin',
  components: {},
  data () {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      seachObj: {
        isEqual: '1',
        yhubSn: ''
        // yhubSn: '01190530763'
      },
      typeOptions: [
        { key: '1', label: 'yhub' },
        { key: '2', label: 'kisae' },
        { key: '3', label: 'lithium' }
      ],
      allCompanyArr: [], // 所有公司
      tableData: [],
      isShowLoading: true,
      showMovePop: false,
      moveObj: {
        fromMcuId: null,
        toMcuId: null,
        clear: 0
      },
      selectCompany: [],
      selectCompany2: []
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    isEqualOptions () {
      return [
        { key: '1', label: i18n.t('adminView.Equal') },
        { key: '2', label: i18n.t('adminView.NotEqual') }
      ]
    }
  },
  watch: {
    'seachObj.fw': {
      handler (newValue, oldValue) {
        if (oldValue && (!newValue || newValue.length == 0)) {
          this.seachObj.isEqual = '1'
          this.queryList()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.queryList()
  },
  created () { },
  methods: {
    inputFwBlur () {
      // 版本输入框失焦时，如果有版本则this.queryList()
      var fw = this.replaceSpace(this.seachObj.fw)
      if ((fw || fw == 0) && fw != '') this.queryList()
    },
    replaceSpace (val) {
      // 去掉空格
      if (val) {
        val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      return val
    },
    queryList () {
      var param = {
        pageNum: this.listQuery.pageInfo.pageNum,
        pageSize: this.listQuery.pageInfo.pageSize,
        k: this.seachObj.yhubSn,
        companyIdList: this.selectCompany,
        equalFwVersion: '',
        notEqualFwVersion: ''
      }
      if (this.seachObj.isEqual == 1) {
        param.equalFwVersion = this.seachObj.fw
      } else {
        param.notEqualFwVersion = this.seachObj.fw
      }
      this.isShowLoading = true
      getUpdateDeviceList(param).then((res) => {
        console.log('res--', res)
        if (res.resultCode == 1001) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          // this.tableData = res.resultModel.list
          res.resultModel.list.forEach((v) => {
            v.lastConnectTime = v.lastConnectTime
              ? getDateAndHour(v.lastConnectTime, 'noSecond')
              : '--'
            v.bootupTime = '--'
            v.realFlowZh = (v.realFlow || v.realFlow == 0) ? (v.realFlow / 1024).toFixed(2) : '--'
            var realFlow = v.realFlow || 0
            var simFlowAmount = v.simFlowAmount || 0
            v.traffic = ((simFlowAmount * 1024 - realFlow) / 1024).toFixed(2)
            // v.expand = {}
            // getLastMessageBootReq({ mcuId: v.yhubMcu }).then((res) => {
            //   if (res.resultCode != 1001 || !res.resultModel) return
            // this.tableData[i].expand.batteryTotalAh = res.resultModel.batteryTotalAh ? (res.resultModel.batteryTotalAh / 100) : '--'
            // v.expand = res.resultModel
            // v.expand.batteryTotalAh = res.resultModel.batteryTotalAh
            //   ? res.resultModel.batteryTotalAh / 100
            //   : '--'
            // v.bootupTime = v.expand.bootupTime = res.resultModel.bootupTime
            //   ? getDateAndHour(
            //     new Date(res.resultModel.bootupTime).getTime(),
            //     'noSecond'
            //   )
            //   : '--'
            // v.expand.configTime = res.resultModel.configTime
            //   ? getDateAndHour(
            //     new Date(res.resultModel.configTime).getTime(),
            //     'noSecond'
            //   )
            //   : '--'
            // v.expand.createTime = res.resultModel.createTime
            //   ? getDateAndHour(
            //     new Date(res.resultModel.createTime).getTime(),
            //     'noSecond'
            //   )
            //   : '--'
            // this.$set(v, 'bootupTime', v.expand.bootupTime)
            // })
          })
          this.tableData = res.resultModel.list
          this.isShowLoading = false

          // this.tableData = [...this.tableData]
        }
      })
    },
    goToDetail (row) {
      var routeData = this.$router.resolve({
        path: '/setting/fwUpdateDetail',
        query: {
          mcuId: row.yhubMcu
        }
      })

      window.open(routeData.href, '_self')
    },
    refreshSim () {
      // 刷新联网卡固件
      manualUpdateSimList().then((res) => {
        if (res.resultCode == 1001) {
          this.$message({
            type: 'success',
            message: i18n.t('adminView.wait5'), // '发送成功，即将开始刷新列表，预计需要5分钟，请耐心等待'
            duration: 5000
          })
        }
      })
    },
    toCopyData (row) {
      // 转移设备弹窗--打开
      this.showMovePop = true
      this.moveObj.fromMcuId = row.yhubMcu
    },
    copyData (row) {
      // 转移设备弹窗--打开
      if (this.moveObj.toMcuId == null || this.moveObj.toMcuId == '') {
        this.$message({
          type: 'error',
          message: i18n.t('adminView.copyDataParamCannotbeEmpty'), // 参数为空
          duration: 5000
        })
        return
      }
      // this.showMovePop = true
      doCopyData(this.moveObj).then((res) => {
        if (res.resultCode == 1001) {
          this.$message({
            type: 'success',
            message: i18n.t('adminView.copyDataSuccess') // '发送成功，即将开始迁移数据，请耐心等待'
            // duration: 5000
            // message: "成功",
          })
        } else {
          if (res.resultMessage.search('not found') != -1) {
            this.$message({
              type: 'error',
              message: i18n.t('adminView.copyDataParamError'), // 参数为空
              duration: 5000
            })
          } if (res.resultMessage.search('data copying') != -1) {
            this.$message({
              type: 'error',
              message: i18n.t('adminView.copyDataing'), // 参数为空
              duration: 5000
            })
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage, // 参数为空
              duration: 5000
            })
          }
        }
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    // 筛选改变事件
    changeSearch () {
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      // 去掉首尾空格
      if (this.seachObj.yhubSn) {
        this.seachObj.yhubSn = this.seachObj.yhubSn
          .replace(/(^\s*)|(\s*$)/g, '')
          .replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '')
          .replace(/(^\s*)|(\s*$)/g, '')
      }
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----startce
    handleSizeChange (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
#yhubIndex {
  // height:100%;
  background: #fff;
  .statusDiv {
    width: 100%;
    height: 20px;
    background: #f3f3f3;
    margin-top: 2px;
  }
  .greenStatus {
    width: 33%;
    background: #43d043;
    height: 20px;
  }
  .yellowStatus {
    width: 66%;
    background: #f7f73f;
    height: 20px;
  }
  .redStatus {
    width: 100%;
    background: #fb2b2b;
    height: 20px;
  }
  .loading {
    position: absolute;
    width: 100%;
    height: 95%;
    background: #fffffff0;
    color: #1990fc;
    z-index: 99;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style lang="scss">
#yhubIndex {
  .deviceNameTable {
    width: 200px;
  }
  .el-button--danger.is-plain,
  .el-button--success.is-plain {
    cursor: context-menu;
  }
  .demo-table-expand .el-form-item {
    margin-bottom: 0;
  }
  .el-radio {
    margin-right: 20px;
  }
  .fwWarp {
    display: inline-block;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    .fwInput {
      width: 100px;
      .el-input__inner {
        // border-right: none;
        position: relative;
        z-index: 22;
        border-radius: 4px 0 0 4px;
        border: none;
        height: 34px;
        line-height: 34px;
      }
    }
    #isEqual {
      width: 100px;
      // border-left: none;
      margin-left: -10px;
      background: #f5f7fa;
      border: none;
      height: 34px;
      line-height: 34px;
    }
  }
}
</style>
